/**
 * Data-room access-request mapper: the `data_room_access_requests` row (joined
 * with the investor profile) → the `AccessRequest` shape the founder UI renders.
 * Pure, so it can be unit-tested without Supabase.
 */

import type { AccessRequest } from '@/components/dataroom';

/** Loose row shape (matches the generated `data_room_access_requests` row + investor join). */
export interface AccessRequestRow {
  id: string;
  investor_profile_id: string;
  message: string | null;
  status: string | null;
  created_at: string | null;
  responded_at: string | null;
  investor?: { id: string; name: string | null; firm: string | null; linkedin_verified?: boolean | null } | null;
}

export function mapAccessRequestRow(row: AccessRequestRow): AccessRequest {
  const status: AccessRequest['status'] =
    row.status === 'approved' || row.status === 'rejected' ? row.status : 'pending';
  return {
    id: row.id,
    investorId: row.investor_profile_id,
    investorName: row.investor?.name ?? 'Investor',
    investorFirm: row.investor?.firm ?? undefined,
    message: row.message ?? undefined,
    status,
    createdAt: row.created_at ?? '',
    respondedAt: row.responded_at ?? undefined,
  };
}
